import { Grid } from '@mui/material';
import { DataGrid, GridColDef, gridClasses } from '@mui/x-data-grid';
import { useEffect, useState, useCallback } from 'react';
import { getClosureList } from 'wisestep-api';
import {
  EmptyTeamsAndUsersIcon,
  getFormatDate,
  WsTypography,
  WsTypoVariants,
  getDateUsingFormat,
} from 'wisestep-base';

import NoDataFoundCard from '../../../components/noDataFoundCard';
import { CustomToolbar } from '../../invoicing/components/DataGridCustomToolBar';
import { ClosureDetailsDTO } from '../types';

const ClosurePlacement = () => {
  const [placementListData, setPlacementListData] = useState<ClosureDetailsDTO[]>();
  const [pageNo, setPageNo] = useState<number>(0);
  const [totalRecord, setTotalRecord] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(25);
  const tableData: Record<string, unknown>[] = [];

  const getClosureListData = useCallback(async () => {
    const response = await getClosureList(pageNo, pageSize);
    setPlacementListData(response.data.content);
    setTotalRecord(response.data.totalElements);
  }, [pageNo, pageSize]);

  useEffect(() => {
    getClosureListData();
  }, [getClosureListData]);

  const getColumns = () => {
    return placementListData ? columns.filter((item) => item.field != 'childCount') : columns;
  };

  placementListData?.map((item) => {
    tableData.push({
      id: item.id,
      ourEntityName: item.ourEntityName,
      clientName: item.clientName,
      positionTitle: item.positionTitle,
      candidateLocationCity: item.candidateLocation,
      joiningDate:
        item?.joiningDate != undefined
          ? getDateUsingFormat(item.joiningDate?.toString(), 'DD-MMM-YY')
          : '',
      contractGuaranteeEndDate: getFormatDate(item.employmentGuaranteeEndDate?.toString() ?? ''),
    });
  });
  const columns: GridColDef[] = [
    {
      field: 'ourEntityName',
      headerName: 'Our Entity',
      flex: 1,
      renderCell: (params) => (
        <WsTypography variant={WsTypoVariants.SUB_TITLE} cursor="pointer" bold>
          {params.row.ourEntityName}
        </WsTypography>
      ),
    },
    {
      field: 'clientName',
      headerName: 'Client Entity',
      flex: 1,
    },
    {
      field: 'positionTitle',
      headerName: 'Job Title',
      flex: 1,
    },
    {
      field: 'candidateLocationCity',
      headerName: 'Job Location',
      flex: 1,
    },
    {
      field: 'joiningDate',
      headerName: 'Start Date',
      flex: 1,
    },
    {
      field: 'contractGuaranteeEndDate',
      headerName: 'End Date',
      flex: 1,
    },
  ];

  return (
    <Grid container sx={{ display: 'flex' }} mt={2}>
      {tableData && tableData?.length > 0 ? (
        <Grid xs={12} sx={{ backgroundColor: 'white' }}>
          <DataGrid
            autoHeight={true}
            components={{ Toolbar: CustomToolbar }}
            columns={getColumns()}
            rows={tableData}
            rowCount={totalRecord}
            onPageChange={(page) => setPageNo(page)}
            pageSize={pageSize}
            rowsPerPageOptions={[25, 50, 75, 100]}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            getRowHeight={() => 'auto'}
            sx={{
              [`& .${gridClasses.cell}`]: {
                py: 1,
              },
            }}
          />
        </Grid>
      ) : (
        <NoDataFoundCard text="No results found." icon={<EmptyTeamsAndUsersIcon />} />
      )}
    </Grid>
  );
};

export default ClosurePlacement;
